import { render, staticRenderFns } from "./DuelsGamesElement.vue?vue&type=template&id=d6d837b6&scoped=true"
import script from "./DuelsGamesElement.vue?vue&type=script&lang=js"
export * from "./DuelsGamesElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsGamesElement.vue?vue&type=style&index=0&id=d6d837b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d837b6",
  null
  
)

export default component.exports